import React from 'react'
import { Link, useLocation } from 'react-router-dom';

const scrollToElement = (id) => {
    const element = document.getElementById(id);
    if (element) {
        const elementTop = element.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
            top: elementTop - 100,
            behavior: 'smooth'
        });
    }
};

const PlSection_1 = () => {
    const location = useLocation();

    return (
        <div className="container">
            <div className="text-center px-20">
                <div className="section-heading">
                    <div className="title-wrapper">
                        <h2 className="section-title has_fade_anim fs-4x  text-grad-1">TruVoice Platform</h2>
                    </div>
                    <div className="text-wrapper">
                        <p className="text has_fade_anim mt-3 fs-1  text-grad-3">
                            Use this simple intuitive UI to make full-featured AI Agents. ...
                        </p>
                    </div>
                    <div className="btn-wrap has_fade_anim mt-10">
                        <Link
                            to="#how-its-works"
                            onClick={() => scrollToElement("how-its-works")}
                            className="wc-btn wc-btn-primary bordered btn-text-flip p-5 me-5 fs-4"
                        >
                            <span data-text="How it works?">How it works?</span>
                        </Link>
                        <Link
                            to="#developer-guide"
                            onClick={() => scrollToElement("developer-guide")}
                            className="wc-btn wc-btn-primary bordered btn-text-flip p-5 me-5 fs-4"
                        >
                            <span data-text="Developer Guide">Developer Guide</span>
                        </Link>
                        <Link
                            to="#pricing"
                            onClick={() => scrollToElement("pricing")}
                            className="wc-btn wc-btn-primary bordered btn-text-flip p-5 fs-4 me-5"
                        >
                            <span data-text="Pricing">Pricing</span>
                        </Link>
                        <Link
                            to="#integrations"
                            onClick={() => scrollToElement("integrations")}
                            className="wc-btn wc-btn-primary bordered btn-text-flip p-5 fs-4"
                        >
                            <span data-text="Integrations">Integrations</span>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export {PlSection_1}
